import { Box, BoxProps } from "@chakra-ui/react";
import { AiOutlineSortDescending } from "react-icons/ai";

export const SortDescending = (props: BoxProps) => {
  return <Box as={AiOutlineSortDescending} height="20px" width="20px" {...props} />;
};
